import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { IS_PRIVATE_API } from '@personal-area/global/http/models';
import { Observable } from 'rxjs';

import { cardVerificationURLs } from '../constants/card-verification';
import { CardVerificationRequest } from '../models/card-verification-request';
import { CardVerificationResponse } from '../models/card-verification-response';

@Injectable()
export class CardVerificationApiService {
  constructor(private _http: HttpClient) {}

  public checkStatus(userId: number): Observable<CardVerificationResponse> {
    return this._http.get<{ card: string }>(cardVerificationURLs.send(userId), {
      context: new HttpContext().set(IS_PRIVATE_API, true),
    });
  }

  public request(
    userId: number,
    data: CardVerificationRequest,
  ): Observable<void> {
    return this._http.post<void>(cardVerificationURLs.send(userId), data, {
      context: new HttpContext().set(IS_PRIVATE_API, true),
    });
  }
}
